<template>
  <div>
    <div
      id="hireModal"
      class="modal fade"
      data-focus="false"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-scrollable">
        <ValidationObserver
          ref="letter"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <div class="letter-modal">
            <div class="note-wrap">
              <div class="letter-title">錄取通知</div>
              <div class="note-title">可動態套入信件內容，請參考以下參數</div>
              <div class="note-table mb-4">
                <table v-if="acceptanceParameters">
                  <tr
                    v-for="parameter in acceptanceParameters"
                    :key="parameter.MailParameterCode"
                  >
                    <th>{{ parameter.MailParameterName }}</th>
                    <td>
                      <span> {{</span>{{ parameter.MailParameterCode
                      }}<span>}} </span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <form @reset.prevent="reset">
              <div class="modal-content border-0">
                <div class="modal-body">
                  <div class="form-group">
                    <label for="">姓名：</label>
                    <span>{{ acceptanceMail.Name }}</span>
                  </div>
                  <div class="form-group">
                    <ValidationProvider
                      rules="required"
                      class="w-100"
                      v-slot="{ errors }"
                    >
                      <label for="">
                        <span style="color: red">*</span>
                        <span>錄取單位：</span>
                      </label>
                      <treeselect
                        :options="departmentOptions"
                        :searchable="true"
                        :show-count="true"
                        :default-expand-level="1"
                        placeholder="請選擇"
                        valueFormat="object"
                        v-model="acceptanceMail.Department"
                      >
                        <label
                          slot="option-label"
                          slot-scope="{
                            node,
                            shouldShowCount,
                            count,
                            labelClassName,
                            countClassName,
                          }"
                          :class="labelClassName"
                          for=""
                        >
                          {{ node.label }}
                          <span v-if="shouldShowCount" :class="countClassName">
                            ({{ count }})
                          </span>
                        </label>
                      </treeselect>
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>
                  <div class="form-group">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <label for="">
                        <span style="color: red">*</span>
                        工作職稱：
                      </label>
                      <el-select
                        class="w-100"
                        filterable
                        placeholder="請選擇"
                        v-model="acceptanceMail.Job"
                      >
                        <el-option
                          v-for="position in positionOptions"
                          :key="position.Code"
                          :label="position.Name"
                          :value="position.Name"
                        >
                        </el-option>
                      </el-select>
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>
                  <div class="form-group">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <label for="">
                        <span style="color: red">*</span>
                        <span>聯絡資訊：</span>
                      </label>
                      <el-select
                        class="w-100"
                        filterable
                        placeholder="請選擇"
                        v-model="acceptanceMail.ContactInfo"
                      >
                        <el-option
                          v-for="person in contactOptions"
                          :key="person.Guid"
                          :label="person.Name"
                          :value="person.Name"
                        >
                        </el-option>
                      </el-select>
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>

                  <div class="form-group">
                    <label for="">附件：</label>
                    <el-upload
                      class="upload-demo"
                      action
                      :auto-upload="false"
                      :show-file-list="false"
                      :on-change="uploadFile"
                    >
                      <el-button size="small" type="primary"
                        >點擊上傳</el-button
                      >
                    </el-upload>
                    <template v-if="uploadFileList">
                      <div v-for="file in uploadFileList" :key="file.FileGuid">
                        <p
                          style="margin-top: 20px; cursor: pointer"
                          @click="
                            $common.downloadFile({
                              fileGuid: file.FileGuid,
                              fileType: file.FileContentType,
                            })
                          "
                        >
                          <eva-icon fill="#000" name="attach-outline" />
                          <span
                            style="margin-left: 15px; vertical-align: text-top"
                          >
                            {{ file.FileName }}
                          </span>
                          <span
                            style="
                              display: inline-block;
                              position: absolute;
                              right: 25px;
                            "
                            @click.stop="
                              removeFile({
                                fileGuid: file.FileGuid,
                                fileGroupGuid: file.FileGroupGuid,
                              })
                            "
                          >
                            <eva-icon fill="#000" name="trash-2-outline" />
                          </span>
                        </p>
                      </div>
                    </template>
                  </div>

                  <div class="form-group">
                    <label for="">錄取信件範本：</label>
                    <el-select
                      class="w-100"
                      clearable
                      placeholder="請選擇"
                      v-model="acceptanceTemplateGuid"
                    >
                      <el-option
                        v-for="template in acceptanceTemplates"
                        :key="template.MailTemplateGuid"
                        :label="template.MailTemplateName"
                        :value="template.MailTemplateGuid"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <div class="form-group">
                    <ValidationProvider
                      rules="required"
                      class="w-100"
                      v-slot="{ errors }"
                    >
                      <label for=""> <span class="mark">*</span>錄取信件主旨： </label>
                      <el-input
                        clearable
                        placeholder="請輸入信件主旨或選擇範本"
                        v-model.trim="acceptanceMail.MailSubject"
                      />
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>

                  <div class="form-group">
                    <ValidationProvider
                      rules="required"
                      class="w-100"
                      v-slot="{ errors }"
                    >
                      <label for=""> <span class="mark">*</span>錄取信件內容： </label>
                      <VueEditor
                        style="background: rgb(255, 255, 255)"
                        v-model="acceptanceMail.MailTemplateBody"
                      />
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>

                  <div class="form-group" v-if="personData.ResumeType == 'DL'">
                    <ValidationProvider
                      rules="required"
                      class="w-100"
                      v-slot="{ errors }"
                    >
                      <label for=""><span class="mark">*</span>是否夾帶offer：</label>
                      <el-select
                        class="w-100"
                        placeholder="請選擇"
                        v-model="acceptanceMail.IsSendOffer"
                      >
                        <el-option label="是" :value="true" />
                        <el-option label="否" :value="false" />
                      </el-select>
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="modal-footer">
                  <button
                    type="reset"
                    class="btn btn-secondary"
                    @click="closeHireMailModal"
                  >
                    取消
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="handleSubmit(preview)"
                  >
                    預覽
                  </button>
                  <button
                    type="button"
                    class="btn btn-success"
                    :disabled="clickDisabled"
                    @click="handleSubmit(sendLetter)"
                  >
                    寄出
                  </button>
                </div>
              </div>
            </form>
          </div>
        </ValidationObserver>
      </div>
    </div>
    <!-- 預覽 Modal -->
    <PreviewMailModal :type="'hire'" :mail="previewData" />
  </div>
</template>

<script>
/* global $ */
import { mapGetters, mapActions } from "vuex";
import PreviewMailModal from "@/components/back/Modal/PreviewMailModal.vue";

export default {
  props: ["personData"],

  name: "HireMailModal",
  components: {
    PreviewMailModal,
  },
  data() {
    return {
      // 錄取通知
      acceptanceParameters: [],
      acceptanceTemplates: [],

      // 所選擇範本的 guid
      acceptanceTemplateGuid: null,
      offerTemplateGuid: null,

      // 部門列表
      departmentOptions: [],
      // 職務列表
      positionOptions: [],

      // 錄取通知信件內容
      acceptanceMail: {},

      // 預覽內容
      previewData: {},
      // 寄出按鈕
      clickDisabled: false,

      // 聯絡資訊
      contactOptions: [],

      // 附件
      fileGroupGuid: "",
      resetFileStatus: true, // 第一次必為 true
      uploadFileList: [], // 上傳附件列表
    };
  },

  watch: {
    showHireMail: function (e) {
      this.acceptanceTemplateGuid = null;
      if (e) {
        this.offerTemplateGuid = null;
        this.acceptanceMail = {
          Name: this.personData.Name,
          Email: this.personData.Email,
          Job: this.personData.Position,
          ContactInfo: null,
          IsSendOffer: null,
          MatchId: this.personData.MatchId,
          Department: this.personData.AppointmentDepartmentGuid
            ? {
                id: this.personData.AppointmentDepartmentGuid,
                label: this.personData.AppointmentDepartment,
              }
            : null,
        };
        this.fileGroupGuid = "";
        this.resetFileStatus = true;
        this.uploadFileList = [];
        this.$refs.letter.reset();
        this.clickDisabled = false;
        $("#hireModal").modal("show");
      } else {
        this.acceptanceMail = {};
        $("#hireModal").modal("hide");
      }
    },

    acceptanceTemplateGuid: function (e) {
      if (e) {
        this.getMailTemplateDetail({ mailType: "acceptance" });
      } else {
        this.acceptanceMail.MailSubject = null;
        this.acceptanceMail.MailTemplateBody = null;
      }
    },
  },

  methods: {
    // 錄取通知
    sendLetter() {
      this.clickDisabled = true;
      this.updateLoading(true);

      this.$api.notice
        .noticeOfHire({
          ...this.acceptanceMail,
          Department: this.acceptanceMail.Department.label,
          MailSenderGuid: this.$cookies.get("userId"),
          FileGroupId: this.fileGroupGuid ? this.fileGroupGuid : null,
          IsSendOffer: this.acceptanceMail.IsSendOffer === true,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$store.commit("OpenHireMailModal", false);
            this.$notify({
              title: "成功",
              message: "錄取通知信已寄出",
              type: "success",
              duration: 2500,
            });
            this.$emit("updatePerson", this.personData.MatchId, "錄取通知");
          }
          this.clickDisabled = false;
          this.updateLoading(false);
        })
        .catch(() => {
          this.clickDisabled = false;
          this.updateLoading(false);
        });
    },

    // 上傳 附件
    uploadFile(file) {
      this.updateLoading(true);

      let fd = new FormData();
      fd.append("File", file.raw);
      fd.append("FileType", file.raw.type);
      fd.append("FileGroupGuid", this.fileGroupGuid);
      fd.append("CreateUser", null);

      this.$api.file.uploadFile(fd).then((response) => {
        if (response.status === 200) {
          this.fileGroupGuid = response.data;
          this.resetFileStatus = false;
          this.getFileList(this.fileGroupGuid);
        }
        this.updateLoading(false);
      });
    },

    // 取得 附件
    getFileList(fileGroupGuid) {
      this.updateLoading(true);

      const params = {
        resetFileStatus: this.resetFileStatus,
      };

      this.$api.file.getFileDetails(params, fileGroupGuid).then((response) => {
        if (response.status === 200) {
          this.uploadFileList = response.data.filter((item) => !item.IsDelete);
        }
        this.updateLoading(false);
      });
    },

    // 刪除 附件
    removeFile({ fileGuid, fileGroupGuid }) {
      this.updateLoading(true);
      this.$api.file.removeFile(fileGuid).then((response) => {
        if (response.status === 200) {
          this.$notify({
            title: "成功",
            message: "刪除成功",
            type: "success",
            duration: 2500,
          });
          this.uploadFileList = [];
          this.resetFileStatus = false;
          this.getFileList(fileGroupGuid);
        }
        this.updateLoading(false);
      });
    },

    // 依guid 取得信件範本內容
    getMailTemplateDetail({ mailType }) {
      this.updateLoading(true);

      let mailTemplateGuid;
      mailTemplateGuid = mailType === "acceptance" ? this.acceptanceTemplateGuid : this.offerTemplateGuid;

      this.$api.mailTemplate
        .getMailTemplateDetail(mailTemplateGuid)
        .then((response) => {
          if (response.status === 200) {
            if (mailType === "acceptance") {
              this.$set(
                this.acceptanceMail,
                "MailSubject",
                response.data.MailTemplateSubject
              );
              this.$set(
                this.acceptanceMail,
                "MailTemplateBody",
                response.data.MailTemplateBody
              );
            } else {
              this.$set(
                this.offerMail,
                "OfferTemplateBody",
                response.data.MailTemplateBody
              );
            }
          }
          this.updateLoading(false);
        });
    },

    // 預覽
    preview() {
      this.previewData = {
        ...this.acceptanceMail,
        Department: this.acceptanceMail.Department.label,
      };
      this.$store.commit("OpenPreviewMailModal", true);
    },

    // 點擊取消
    closeHireMailModal() {
      this.$store.commit("OpenHireMailModal", false);
    },

    async getData() {
      await this.$http
        .all([
          this.$api.department.getDepartment(),
          this.$api.position.getPositionPaging({
            isEnabled: true,
            isPaging: false,
          }),
          ///// 以下為錄取信件所需資訊 /////
          this.$api.mailTemplate.getMailParameter(
            "AED915EB-05AF-47F6-A0AA-5C733776D149"
          ),
          this.$api.mailTemplate.getMailTemplatePaging(
            { isPaging: false },
            "Hired"
          ),
          this.$api.contactInfo.getContactInfo(),
        ])
        .then(
          this.$http.spread(
            (
              department,
              position,
              acceptanceParameter,
              acceptanceTemplate,
              contact
            ) => {
              // 取得 部門選項
              this.departmentOptions = department.data;
              // 取得 職務選項
              this.positionOptions = position.data.Datas.map((item) => {
                return {
                  Code: item.PositionCode,
                  Name: item.PositionName,
                };
              });
              // 取得 錄取通知參數
              this.acceptanceParameters = acceptanceParameter.data;
              // 取得 錄取通知範本
              this.acceptanceTemplates = acceptanceTemplate.data.Datas;
              // 取得 聯絡資訊
              this.contactOptions = contact.data;
            }
          )
        );
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  computed: {
    ...mapGetters(["showHireMail"]),
  },

  created() {
    this.getData();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
    this.$store.commit("OpenHireMailModal", false);
  },
};
</script>
